import { proxy, homepage } from '../../package.json'

// 测试环境请求的Base URL
export const BASE_URL_DEV = proxy // DEV请在package.json中配置proxy

// 生产环境请求的Base URL
export const BASE_URL_PROD = homepage // 请在package.json中配置homepage

// 路由根路径
// export const BASE_PATH = '/plugin_api/admin/147/campus'
export const BASE_PATH = ''
